var e = "11.3.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
